/**
 * Food & drink emoji category with searchable keywords
 */
export const food = {
  name: 'Food',
  icon: '🍔',
  emojis: [
    { emoji: '🍇', keywords: ['grapes', 'fruit', 'wine', 'purple', 'vine'] },
    { emoji: '🍈', keywords: ['melon', 'fruit', 'cantaloupe', 'honeydew', 'green'] },
    { emoji: '🍉', keywords: ['watermelon', 'fruit', 'summer', 'red', 'seeds'] },
    { emoji: '🍊', keywords: ['orange', 'tangerine', 'fruit', 'citrus', 'vitamin'] },
    { emoji: '🍋', keywords: ['lemon', 'citrus', 'fruit', 'sour', 'yellow'] },
    { emoji: '🍌', keywords: ['banana', 'fruit', 'yellow', 'monkey', 'potassium'] },
    { emoji: '🍍', keywords: ['pineapple', 'fruit', 'tropical', 'pizza', 'hawaii'] },
    { emoji: '🥭', keywords: ['mango', 'fruit', 'tropical', 'sweet', 'orange'] },
    { emoji: '🍎', keywords: ['apple', 'red', 'fruit', 'healthy', 'teacher'] },
    { emoji: '🍏', keywords: ['apple', 'green', 'fruit', 'healthy', 'granny'] },
    { emoji: '🍐', keywords: ['pear', 'fruit', 'green', 'healthy', 'sweet'] },
    { emoji: '🍑', keywords: ['peach', 'fruit', 'butt', 'emoji', 'fuzzy'] },
    { emoji: '🍒', keywords: ['cherries', 'fruit', 'red', 'pair', 'sweet'] },
    { emoji: '🍓', keywords: ['strawberry', 'fruit', 'red', 'berry', 'sweet'] },
    { emoji: '🫐', keywords: ['blueberries', 'fruit', 'berry', 'blue', 'healthy'] },
    { emoji: '🥝', keywords: ['kiwi', 'fruit', 'green', 'fuzzy', 'tropical'] },
    { emoji: '🍅', keywords: ['tomato', 'vegetable', 'red', 'salad', 'fruit'] },
    { emoji: '🫒', keywords: ['olive', 'oil', 'green', 'mediterranean', 'food'] },
    { emoji: '🥥', keywords: ['coconut', 'tropical', 'fruit', 'palm', 'milk'] },
    { emoji: '🥑', keywords: ['avocado', 'fruit', 'green', 'guacamole', 'toast'] },
    { emoji: '🍆', keywords: ['eggplant', 'aubergine', 'vegetable', 'purple', 'emoji'] },
    { emoji: '🥔', keywords: ['potato', 'vegetable', 'fries', 'starch', 'spud'] },
    { emoji: '🥕', keywords: ['carrot', 'vegetable', 'orange', 'healthy', 'rabbit'] },
    { emoji: '🌽', keywords: ['corn', 'maize', 'vegetable', 'cob', 'yellow'] },
    { emoji: '🌶️', keywords: ['pepper', 'hot', 'chili', 'spicy', 'red'] },
    { emoji: '🫑', keywords: ['pepper', 'bell', 'vegetable', 'green', 'sweet'] },
    { emoji: '🥒', keywords: ['cucumber', 'vegetable', 'pickle', 'green', 'salad'] },
    { emoji: '🥬', keywords: ['leafy', 'green', 'lettuce', 'vegetable', 'salad'] },
    { emoji: '🥦', keywords: ['broccoli', 'vegetable', 'green', 'healthy', 'tree'] },
    { emoji: '🧄', keywords: ['garlic', 'food', 'flavor', 'cooking', 'vampire'] },
    { emoji: '🧅', keywords: ['onion', 'vegetable', 'cry', 'cooking', 'layers'] },
    { emoji: '🥜', keywords: ['peanuts', 'nuts', 'snack', 'allergy', 'legume'] },
    { emoji: '🍞', keywords: ['bread', 'loaf', 'toast', 'carbs', 'bakery'] },
    { emoji: '🥐', keywords: ['croissant', 'bread', 'french', 'pastry', 'breakfast'] },
    { emoji: '🥖', keywords: ['baguette', 'bread', 'french', 'bakery', 'long'] },
    { emoji: '🫓', keywords: ['flatbread', 'pita', 'naan', 'bread', 'wrap'] },
    { emoji: '🥨', keywords: ['pretzel', 'snack', 'twisted', 'salty', 'german'] },
    { emoji: '🥯', keywords: ['bagel', 'bread', 'breakfast', 'cream', 'cheese'] },
    { emoji: '🥞', keywords: ['pancakes', 'breakfast', 'stack', 'syrup', 'butter'] },
    { emoji: '🧇', keywords: ['waffle', 'breakfast', 'syrup', 'belgian', 'grid'] },
    { emoji: '🧀', keywords: ['cheese', 'dairy', 'swiss', 'yellow', 'wedge'] },
    { emoji: '🍖', keywords: ['meat', 'bone', 'bbq', 'drumstick', 'protein'] },
    { emoji: '🍗', keywords: ['chicken', 'leg', 'poultry', 'drumstick', 'fried'] },
    { emoji: '🥩', keywords: ['steak', 'meat', 'beef', 'rare', 'protein'] },
    { emoji: '🥓', keywords: ['bacon', 'meat', 'breakfast', 'pork', 'crispy'] },
    { emoji: '🍔', keywords: ['burger', 'hamburger', 'fast', 'food', 'beef'] },
    { emoji: '🍟', keywords: ['fries', 'french', 'fast', 'food', 'potato'] },
    { emoji: '🍕', keywords: ['pizza', 'slice', 'italian', 'cheese', 'pepperoni'] },
    { emoji: '🌭', keywords: ['hotdog', 'sausage', 'fast', 'food', 'bun'] },
    { emoji: '🥪', keywords: ['sandwich', 'bread', 'lunch', 'sub', 'deli'] },
    { emoji: '🌮', keywords: ['taco', 'mexican', 'shell', 'tuesday', 'food'] },
    { emoji: '🌯', keywords: ['burrito', 'wrap', 'mexican', 'food', 'tortilla'] },
    { emoji: '🫔', keywords: ['tamale', 'mexican', 'corn', 'food', 'wrapped'] },
    { emoji: '🥙', keywords: ['pita', 'kebab', 'falafel', 'stuffed', 'middle'] },
    { emoji: '🧆', keywords: ['falafel', 'food', 'middle', 'eastern', 'chickpea'] },
    { emoji: '🥚', keywords: ['egg', 'food', 'breakfast', 'chicken', 'protein'] },
    { emoji: '🍳', keywords: ['egg', 'fried', 'cooking', 'breakfast', 'pan'] },
    { emoji: '🥘', keywords: ['paella', 'pan', 'food', 'spanish', 'rice'] },
    { emoji: '🍲', keywords: ['pot', 'food', 'stew', 'soup', 'cooking'] },
    { emoji: '🫕', keywords: ['fondue', 'cheese', 'chocolate', 'pot', 'dip'] },
    { emoji: '🥣', keywords: ['bowl', 'cereal', 'breakfast', 'spoon', 'milk'] },
    { emoji: '🥗', keywords: ['salad', 'healthy', 'green', 'bowl', 'vegetable'] },
    { emoji: '🍿', keywords: ['popcorn', 'movie', 'snack', 'theater', 'corn'] },
    { emoji: '🧈', keywords: ['butter', 'dairy', 'spread', 'cooking', 'fat'] },
    { emoji: '🧂', keywords: ['salt', 'seasoning', 'shaker', 'flavor', 'sodium'] },
    { emoji: '🥫', keywords: ['can', 'canned', 'food', 'tin', 'preserved'] },
    { emoji: '🍱', keywords: ['bento', 'box', 'japanese', 'lunch', 'food'] },
    { emoji: '🍘', keywords: ['rice', 'cracker', 'japanese', 'snack', 'seaweed'] },
    { emoji: '🍙', keywords: ['rice', 'ball', 'onigiri', 'japanese', 'seaweed'] },
    { emoji: '🍚', keywords: ['rice', 'cooked', 'bowl', 'white', 'asian'] },
    { emoji: '🍛', keywords: ['curry', 'rice', 'indian', 'japanese', 'food'] },
    { emoji: '🍜', keywords: ['noodles', 'ramen', 'bowl', 'soup', 'asian'] },
    { emoji: '🍝', keywords: ['spaghetti', 'pasta', 'italian', 'noodles', 'marinara'] },
    { emoji: '🍠', keywords: ['sweet', 'potato', 'yam', 'roasted', 'vegetable'] },
    { emoji: '🍢', keywords: ['oden', 'skewer', 'japanese', 'food', 'stick'] },
    { emoji: '🍣', keywords: ['sushi', 'japanese', 'fish', 'rice', 'raw'] },
    { emoji: '🍤', keywords: ['shrimp', 'fried', 'tempura', 'seafood', 'prawn'] },
    { emoji: '🍥', keywords: ['fish', 'cake', 'narutomaki', 'japanese', 'swirl'] },
    { emoji: '🥮', keywords: ['moon', 'cake', 'chinese', 'festival', 'autumn'] },
    { emoji: '🍡', keywords: ['dango', 'japanese', 'dessert', 'mochi', 'skewer'] },
    { emoji: '🥟', keywords: ['dumpling', 'gyoza', 'dim', 'sum', 'chinese'] },
    { emoji: '🥠', keywords: ['fortune', 'cookie', 'chinese', 'dessert', 'message'] },
    { emoji: '🥡', keywords: ['takeout', 'box', 'chinese', 'food', 'container'] },
    { emoji: '🦪', keywords: ['oyster', 'seafood', 'shell', 'pearl', 'ocean'] },
    { emoji: '🍦', keywords: ['ice', 'cream', 'cone', 'soft', 'serve', 'dessert'] },
    { emoji: '🍧', keywords: ['shaved', 'ice', 'dessert', 'cold', 'sweet'] },
    { emoji: '🍨', keywords: ['ice', 'cream', 'sundae', 'dessert', 'bowl'] },
    { emoji: '🍩', keywords: ['donut', 'doughnut', 'dessert', 'sweet', 'sprinkles'] },
    { emoji: '🍪', keywords: ['cookie', 'dessert', 'sweet', 'chocolate', 'chip'] },
    { emoji: '🎂', keywords: ['birthday', 'cake', 'celebration', 'party', 'candles'] },
    { emoji: '🍰', keywords: ['cake', 'shortcake', 'slice', 'dessert', 'strawberry'] },
    { emoji: '🧁', keywords: ['cupcake', 'dessert', 'sweet', 'muffin', 'frosting'] },
    { emoji: '🥧', keywords: ['pie', 'dessert', 'thanksgiving', 'apple', 'slice'] },
    { emoji: '🍫', keywords: ['chocolate', 'bar', 'candy', 'sweet', 'cocoa'] },
    { emoji: '🍬', keywords: ['candy', 'sweet', 'wrapper', 'sugar', 'treat'] },
    { emoji: '🍭', keywords: ['lollipop', 'candy', 'sweet', 'swirl', 'sugar'] },
    { emoji: '🍮', keywords: ['custard', 'pudding', 'flan', 'dessert', 'caramel'] },
    { emoji: '🍯', keywords: ['honey', 'pot', 'sweet', 'bee', 'golden'] },
    { emoji: '🍼', keywords: ['baby', 'bottle', 'milk', 'infant', 'formula'] },
    { emoji: '🥛', keywords: ['milk', 'glass', 'dairy', 'drink', 'white'] },
    { emoji: '☕', keywords: ['coffee', 'hot', 'drink', 'cafe', 'espresso', 'tea'] },
    { emoji: '🫖', keywords: ['teapot', 'tea', 'drink', 'hot', 'brew'] },
    { emoji: '🍵', keywords: ['tea', 'green', 'cup', 'matcha', 'japanese'] },
    { emoji: '🍶', keywords: ['sake', 'japanese', 'alcohol', 'bottle', 'rice'] },
    { emoji: '🍾', keywords: ['champagne', 'bottle', 'celebrate', 'party', 'pop'] },
    { emoji: '🍷', keywords: ['wine', 'glass', 'red', 'drink', 'alcohol'] },
    { emoji: '🍸', keywords: ['cocktail', 'martini', 'drink', 'alcohol', 'bar'] },
    { emoji: '🍹', keywords: ['tropical', 'drink', 'cocktail', 'vacation', 'umbrella'] },
    { emoji: '🍺', keywords: ['beer', 'mug', 'drink', 'alcohol', 'pub'] },
    { emoji: '🍻', keywords: ['beers', 'cheers', 'clinking', 'mugs', 'celebrate'] },
    { emoji: '🥂', keywords: ['champagne', 'glasses', 'cheers', 'toast', 'celebrate'] },
    { emoji: '🥃', keywords: ['whiskey', 'tumbler', 'glass', 'alcohol', 'bourbon'] },
    { emoji: '🥤', keywords: ['cup', 'straw', 'soda', 'drink', 'takeout'] },
    { emoji: '🧋', keywords: ['bubble', 'tea', 'boba', 'drink', 'tapioca'] },
    { emoji: '🧃', keywords: ['juice', 'box', 'drink', 'kids', 'straw'] },
    { emoji: '🧉', keywords: ['mate', 'drink', 'tea', 'south', 'american'] },
    { emoji: '🧊', keywords: ['ice', 'cube', 'cold', 'frozen', 'drink'] },
  ],
};

export default food;

